import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-dvv',
  templateUrl: './dvv.component.html',
  styleUrls: ['./dvv.component.scss']
})
export class DvvComponent implements OnInit {
  @HostListener("click") onClick(){
    this.checkRoute();
  }
  fullWidth=false;
  showSideMenu=true;
  constructor() {
   }

  ngOnInit(): void {
    this.checkRoute();
  }
  // ngDoCheck(): void {
  //   this.checkRoute();
  //   console.log('inside')
  // }

  splitUrl(){
    let url=location.pathname.split('/');
    if(url.length === 3 ){
      this.showSideMenu=true;
      this.fullWidth=false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
